function Coords()
{
    var offset = {
        left: 0,
        top: 4
    };

    this.opt = {
        snapRelated: null
    };

    function setXY(source, holder)
    {

        var holderName = holder;

        try {
            source = $(source);
            holder = $(holder);

            var sourcePos = source.offset();

            var left = sourcePos.left + offset.left;
            var top = sourcePos.top + source.outerHeight() + offset.top;

            var newOffset = {
                left: sourcePos.left + offset.left,
                top: sourcePos.top + source.outerHeight() + offset.top
            };

            newOffset = this.fixPositionForViewport(newOffset, holder.children().first());

            var holderParentOffset = {
                left: 0,
                top: 0
            };

            var $holderOffsetParent = holder.offsetParent();

            if ($holderOffsetParent && $holderOffsetParent.offset()) {
                holderParentOffset = {
                    left: $holderOffsetParent.offset().left,
                    top: $holderOffsetParent.offset().top
                };
            }

            if (ApplicationProperties.get('holderPosition')) {
                holderPosition = ApplicationProperties.get('holderPosition');
                for (var i = 0; i < 2; i++) {
                    if (holderPosition[i].holder === holderName) {
                        newOffset.left = (newOffset.left - holderPosition[i].left);
                        newOffset.top = (newOffset.top - holderPosition[i].top);
                    }
                }
            }

            holder.css(
                {
                    left: (newOffset.left - holderParentOffset.left) + 'px',
                    top: (newOffset.top - holderParentOffset.top) + 'px'
                }
            );
        } catch (e) {
        }

    }

    this.setXY = setXY;

    /*
     * if element is outside viewport on x axis, move it back in
     */
    function fixPositionForViewport(pos, elm)
    {
        var width = parseInt(elm.css('width'), 10);
        var right = (width + pos.left);

        if (this.opt.snapRelated && $(this.opt.snapRelated).length) {
            var snapRight = $(this.opt.snapRelated).offset().left + $(this.opt.snapRelated).width();
        } else {
            var snapRight = $(window).width();
        }

        var offsetToWindowRight = (snapRight - right);

        if (offsetToWindowRight < 0) {
            return {
                left: (pos.left + offsetToWindowRight),
                top: pos.top
            };
        }

        return pos;
    }

    this.fixPositionForViewport = fixPositionForViewport;
}
var coords = new Coords();